(function () {
  function initWishlistButtons(root) {
    if (!window.WishListHero_SDK) return;
    const scope = root || document;
    const buttons = scope.querySelectorAll('.wishlist-hero-custom-button:not(.wlh-initialized)');
    buttons.forEach(function (btn) {
      window.WishListHero_SDK.InitializeAddToWishListButton({
        ButtonClassElement: btn.classList.value.split(' ').join('.'),
        ProductId: Number.parseInt(btn.dataset.wlhId, 10),
        ProductLink: btn.dataset.wlhLink,
        ProductVariantId: Number.parseInt(btn.dataset.wlhVariantid, 10),
        ProductPrice: Number.parseInt(btn.dataset.wlhPrice, 10),
        ProductTitle: btn.dataset.wlhName,
        ProductImage: btn.dataset.wlhImage,
        ButtonMode: 'icon_only',
        WishlistHash: ''
      });
      btn.classList.add('wlh-initialized');
    });
  }
  window.initWishlistButtons = initWishlistButtons;
})();


if (!customElements.get("tpt-section-lazyload")) {
	customElements.define(
		"tpt-section-lazyload",
		class TptSectionLazyload extends HTMLElement {
			constructor() {
				super();

				this.elementRender = this.querySelector("[data-lazyload-element]");
			}

			connectedCallback() {
				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					fetch(this.dataset.url)
						.then((response) => response.text())
						.then((text) => {
							const responseHTML = new DOMParser().parseFromString(text, "text/html");
							const htmlSection = responseHTML.querySelector(".tpt-section").innerHTML;

							this.elementRender.innerHTML = htmlSection;
						})
						.finally(() => {
							setTimeout(() => {
								this.classList.add("tpt-section_loaded");
								console.log("this.classList", this.classList);
								if (this.dataset.url.includes('lazy_feature_collection')) {
									if (window.initWishlistButtons)
										window.initWishlistButtons();
								}
								// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
								this.querySelectorAll("script").forEach((oldScriptTag) => {
									const newScriptTag = document.createElement("script");
									Array.from(oldScriptTag.attributes).forEach((attribute) => {
										newScriptTag.setAttribute(attribute.name, attribute.value);
									});
									newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
									oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
								});
							}, 100);
						})
						.catch((e) => {
							console.error(e);
						});
				};

				new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 200px 0px" }).observe(this);
			}
		}
	);
}
